import { AlternativePrice, Price } from 'src/types';

export enum PriceDisplayEnum {
  PRICE = 'price-excludes-shipping',
  PRICE_INCLUDES_SHIPPING = 'price_includes_shipping',
}

export type PriceDisplay =
  | PriceDisplayEnum.PRICE
  | PriceDisplayEnum.PRICE_INCLUDES_SHIPPING;

export enum SortOptionEnum {
  PRICE = 'price',
  PRICEANDSTOCKSTATUS = 'price_in_stock',
  RECOMMENDED = 'recommended',
  FEATURED = 'featured',
}

export type SortOption =
  | SortOptionEnum.PRICE
  | SortOptionEnum.RECOMMENDED
  | SortOptionEnum.PRICEANDSTOCKSTATUS
  | SortOptionEnum.FEATURED;

export enum FilterTypeEnum {
  PRICES_INC_SHIPPING,
  IN_STOCK,
  FEATURED_SHOP,
  AUTHORIZED_DEALER,
  PRIMARY_MARKET,
  VARIANT_SIZE,
}

export type FilterType =
  | FilterTypeEnum.PRICES_INC_SHIPPING
  | FilterTypeEnum.IN_STOCK
  | FilterTypeEnum.FEATURED_SHOP
  | FilterTypeEnum.AUTHORIZED_DEALER
  | FilterTypeEnum.PRIMARY_MARKET
  | FilterTypeEnum.VARIANT_SIZE;

export enum FilterUIPlacementEnum {
  PRODUCT_HEADER,
  FILTER_MENU,
  OFFERLIST_HEADER,
}

export type FilterUIPlacement =
  | FilterUIPlacementEnum.PRODUCT_HEADER
  | FilterUIPlacementEnum.FILTER_MENU
  | FilterUIPlacementEnum.OFFERLIST_HEADER;

export type FilterOffer = Price | AlternativePrice | null | undefined;

export type FilterSelection = string[];

export interface IFilterTypeSelection {
  type: FilterType;
  selection?: FilterSelection;
}

export interface IFilterConfig {
  enabled: boolean;
  type: FilterType;
  placement: FilterUIPlacement;
  filterFn: (offer: FilterOffer, selection?: FilterSelection) => boolean;
  missingInfoFn?: (offer: FilterOffer, selection?: FilterSelection) => boolean; // Provide to keep offers with missing info
  filterAlternativeOffers: boolean;
}
